import React from 'react';
import { motion } from 'framer-motion';
export function MasterPackSection() {
  const benefits = [{
    title: '¿Qué vas a recibir?',
    items: ['📚 4 libros digitales completos', '🎉 Más de 500 ideas', '🗝️ Juegos secretos', '💌 Frases con propósito', '🎁 Bonos exclusivos']
  }, {
    title: '¿Qué vas a lograr?',
    items: ['💬 Charlar más y conectar de verdad', '😄 Crear recuerdos inolvidables', '💖 Fortalecer la confianza', '⏰ Aprovechar el tiempo juntos', '✨ Salir de la rutina y sentirte presente']
  }];
  return <section className="cv-auto py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-950 relative" data-id="element-147">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple-600/5 rounded-full blur-[100px] pointer-events-none hidden md:block" data-id="element-148" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-151">
            💞 ¿Por qué es único?
          </h2>
          <p className="text-xl text-gold-400 font-medium" data-id="element-152">
            Todo lo que necesitás para reconectar con tu familia.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-153">
          {benefits.map((col, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.4
        }} className="bg-navy-900/80 border border-gold-500/30 rounded-3xl p-6 md:p-8 shadow-xl backdrop-blur-sm" data-id="element-154">
              <h3 className="text-xl font-bold text-white mb-6 pb-4 border-b border-navy-800" data-id="element-155">
                {col.title}
              </h3>
              <div className="space-y-4" data-id="element-156">
                {col.items.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-157">
                    <div className="w-2 h-2 rounded-full bg-gold-500 mt-2 flex-shrink-0 shadow-[0_0_8px_rgba(234,179,8,0.8)]" data-id="element-158" />
                    <span className="text-slate-200 text-sm md:text-base" data-id="element-159">
                      {item}
                    </span>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}